import { createStyles, makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(
	theme =>
		createStyles({
			root: {
				background: theme.palette.common.white,
				boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.05)",
				padding: "5px 0px"
			},
			menu: {
				width: "100vw",
				overflowX: "scroll",
				maxWidth: 435,
				display: "inline-block",
				position: "relative",
				whiteSpace: "nowrap"
			},
			menuItem: {
				width: "max-content",
				padding: "5px 0px 0px 10px"
			},
			btnMenu: {
				padding: "10px 25px",
				background: theme.palette.grey[600],
				borderRadius: 6,
				fontSize: 14,
				transition: "all 0.3s",
				cursor: "pointer",
				"&:active": {
					opacity: 0.7,
					background: theme.palette.primary.main,
					transition: "width 2s, height 4s",
					transitionTimingFunction: "ease-out"
				}
			}
		}),
	{
		name: "MenuProduct",
		index: 1
	}
);

export default useStyles;
